import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import getMemoListRequest from "./requests/getMemoListRequest";
import getMemoRequest from "./requests/getMemoRequest";
import createMemoRequest from "./requests/createMemoRequest";
import updateMemoRequest from "./requests/updateMemoRequest";
import deleteMemoRequest from "./requests/deleteMemoRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const memosEndpoints: RequestDefinitionData[] = [
    getMemoListRequest,
    getMemoRequest,
    createMemoRequest,
    updateMemoRequest,
    deleteMemoRequest,
];

export const memosHeader = {
    title: 'Memo',
    description: 'This is an object representing a Fishbowl memo. Memos are used to add information to fishbowl objects.',
    linkName: 'Memos',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Purchase-Order#Memo_tab',
    endpoints: memosEndpoints,
};

export const jsonObject: Json = {
    title: 'THE MEMO OBJECT',
    json: {
        "id": 42,
        "memo": "This is a memo",
        "username": "admin",
        "dateCreated": "2021-02-26T13:59:53.171-0700"
    }
};

export const memoAttributes: Attribute[] = [
    {
        name: 'id',
        type: 'integer',
        description: 'The memo\'s unique identification number.'
    },
    {
        name: 'memo',
        type: 'string',
        description: 'The text inside the memo.'
    },
    {
        name: 'username',
        type: 'string',
        description: 'Username of the user who created or modified the memo.'
    },
    {
        name: 'dateCreated',
        type: 'date',
        description: 'The date the memo was created.'
    }
];
